// extracted by mini-css-extract-plugin
module.exports = {"page":"style__page__Q-8uk","body":"style__body__8kyoT","robot":"style__robot__dAqDf","preloadImages":"style__preloadImages__BBo6n"};